import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { righeConfronto, titoloImmobile } from '../../../utils/immobili';
import Icona from '../Icone';
import { useTraduzioni } from '../../../i18n';

// Due case affiancate: prezzo, €/m², m², locali, piano, spese, agenzia, parere, dintorni.
// Per prezzo, €/m² e spese la cifra più bassa è in verde; per la superficie la più alta.
// `note`: frasi sotto il titolo (es. una casa tolta dal confronto, case nascoste dal filtro).
const MIGLIORE = { prezzo: 'basso', mq: 'basso', spese: 'basso', superficie: 'alto' };
const numero = (testo) => (testo ? parseFloat(String(testo).replace(/[^\d,]/g, '').replace(',', '.')) : NaN);

// Si sceglie la seconda casa scorrendo l'elenco: il confronto compare sopra le card, anche 2.900 px più su a 390 px.
// Quando si apre (o cambia la coppia) lo si porta in vista, se non lo è già.
export const usePortaInVista = (chiave) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof el.scrollIntoView !== 'function') return;
    const r = el.getBoundingClientRect();
    if (r.top >= 0 && r.top < window.innerHeight * 0.6) return; // già davanti agli occhi
    const ridotto = !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: ridotto ? 'auto' : 'smooth', block: 'start' });
  }, [chiave]);
  return ref;
};

const Confronto = ({ coppia, onChiudi, note = [] }) => {
  const { t, l } = useTraduzioni();
  const [a, b] = coppia;
  // come la card: la scheda sa da quale elenco si arriva e "Tutti gli immobili" ci riporta
  const { search } = useLocation();
  const ref = usePortaInVista(`${a.immobile.id}|${b.immobile.id}`);
  return (
    <section className="card confronto r" data-testid="confronto" ref={ref}>
      <div className="ttl">
        <div className="i"><Icona nome="confronta" /></div><h2>{t('immobili.confronto.titolo')}</h2>
        <a href="#chiudi" role="button" onClick={(e) => { e.preventDefault(); onChiudi(); }}>{t('comune.chiudi')}</a>
      </div>
      {note.filter(Boolean).map((n) => <p key={n} className="nota-confronto" role="status">{n}</p>)}
      <div className="tabella-scorre">
        <table>
          <thead>
            <tr>
              <th scope="col"><span className="sr">{t('immobili.confronto.voce')}</span></th>
              {[a, b].map((e) => <th key={e.immobile.id} scope="col"><Link to={`/immobili/${encodeURIComponent(e.immobile.id)}`} state={{ daElenco: search || '' }}>{titoloImmobile(e.immobile, l)}</Link></th>)}
            </tr>
          </thead>
          <tbody>
            {righeConfronto(a, b, l).map((riga) => {
              const [x, y] = riga.valori.map(numero);
              const verso = MIGLIORE[riga.chiave];
              const meglio = verso && Number.isFinite(x) && Number.isFinite(y) && x !== y
                ? ((verso === 'basso') === (x < y) ? 0 : 1) : null;
              return (
                <tr key={riga.chiave}>
                  <th scope="row"><span className="riga-conf">{riga.icona && <Icona nome={riga.icona} />}{riga.nome}</span></th>
                  {riga.valori.map((v, i) => (
                    <td key={i} className={v == null ? 'vuota' : meglio === i ? 'meglio' : undefined}>{v ?? '—'}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Confronto;
